"use client"

import { Link } from "react-router-dom"
import { ArrowLeft, Download } from "lucide-react"

const AGENDA_SRC = "/images/CTS2026chennai-agenda.jpg"

export function AgendaPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-green-50">
      {/* Top bar */}
      <header className="sticky top-0 z-40 border-b border-green-100 bg-white/80 backdrop-blur-md">
        <div className="container mx-auto flex items-center justify-between gap-3 px-4 py-3">
          <Link to="/chennai" className="flex items-center gap-2 text-green-700 transition hover:text-green-800">
            <ArrowLeft className="h-5 w-5" />
            <span className="font-medium">Back to CTS 2026</span>
          </Link>
          <a
            href={AGENDA_SRC}
            download="CTS2026-Chennai-Agenda.jpg"
            className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-3.5 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-green-700"
          >
            <Download className="h-4 w-4" />
            <span className="hidden sm:inline">Download</span>
          </a>
        </div>
      </header>

      <main className="container mx-auto px-3 py-6 sm:px-4 md:py-10">
        <div className="mx-auto mb-6 max-w-3xl text-center">
          <h1 className="text-2xl font-extrabold text-green-800 md:text-3xl">Event Agenda</h1>
          <p className="mt-1 text-sm text-green-700 md:text-base">
            Candela Technology Summit 2026 · Chennai Edition · July 3, 2026
          </p>
        </div>

        {/* A4 vertical agenda — fills width on phones, capped & centered on larger screens */}
        <div className="mx-auto w-full max-w-3xl">
          <img
            src={AGENDA_SRC}
            alt="Candela Technology Summit 2026, Chennai Edition — full event agenda"
            className="h-auto w-full rounded-xl border border-green-100 shadow-2xl"
          />
        </div>

        <p className="mx-auto mt-6 max-w-3xl text-center text-xs text-green-500">
          Tip: pinch to zoom, or use Download for the full-resolution agenda.
        </p>
      </main>
    </div>
  )
}
